<script>
  import { onMount } from 'svelte'
  import Menu from '../components/Menu.svelte'
  let date = '2021-01-01'
  import { timeParse, timeFormat } from 'd3-time-format'
  let parseDate = timeParse('%Y-%m-%d')
  let formatDate = timeFormat('%A %B %-d')

  export let name

  export let videos = []

  onMount(async function () {
    const response = await fetch(
      'https://hosted.mediahack.co.za/looting/api/video.php'
    )
    videos = await response.json()
    videos.forEach((d) => {
      d.origdate = d.date
      d.date = formatDate(parseDate(d.date))
    })
  })

  function playVideo(id) {
    // get status
    if (document.getElementById(id).paused) {
      document.getElementById(id).play()
      document.querySelector(`#vp${id}`).style.display = 'none'
    } else {
      document.getElementById(id).pause()
      document.querySelector(`#vp${id}`).style.display = 'block'
    }
  }
  function updateDate(origdate, newDate) {
    console.log({ date, origdate })

    if (date !== origdate) {
      date = origdate
      return newDate
    } else {
      date = origdate
      return ''
    }
  }
</script>

<div class="stream">
  <div class="menu-wrap"><Menu /></div>
  <section>
    {#await videos}
      <div>... waiting</div>
    {:then videos}
      {#each videos as video}
        <div class="video">
          {#if date !== video.origdate}
            <div class="date">
              {updateDate(video.origdate, video.date)}
            </div>
          {/if}

          <!-- <div class="name">
            {video.link}
          </div> -->

          {#if video.tweet !== ''}
            <div />
          {/if}

          <video
            controls
            id={video.link}
            width="600px"
            on:click={() => {
              playVideo(video.link)
            }}
          >
            <source
              src="https://hosted.mediahack.co.za/looting/video/{video.link}"
              type="video/mp4"
            />
            Your browser does not support the video tag.
          </video>

          <div class="desc">
            {video.description}
            {#if video.tweet !== ''}
              <a href={video.tweet} class="link" target="_blank">source</a>
            {/if}
          </div>
        </div>
      {/each}
    {/await}
  </section>
</div>

<style>
  .menu-wrap {
    width: 100%;
    text-align: center;
  }
  .stream {
    margin-top: 0px;
    padding-top: 30px;
    background: #1a1a1a;
    color: #fff;
  }

  .video {
    margin: auto;
    /* width: 600px; */
    /* border: 1px solid; */
    margin-top: 10px;
    margin-bottom: 20px;
  }

  .link {
    color: lightgray;
  }
  .date {
    font-weight: 700;
    font-family: var(--titleFont);
    font-size: 1.2rem;
    margin-bottom: 10px;
  }
  .desc {
    font-size: 0.9rem;
    color: rgb(192, 192, 192);
  }
</style>
